export const enum Store {
  APP = 'app',
  EVENT = 'event',
  MEMBER = 'member',
  LOCATION = 'location',
  INVOICE_RECIPIENT = 'invoice_recipient',
  CUSTOMER = 'customer',
  CART = 'cart',
  PAYMENT_INTERVAL = 'payment_interval'
}
